// extracted by mini-css-extract-plugin
module.exports = {"svg":"LogoSvg_svg_3aw_q","path":"LogoSvg_path_1ovIs"};